module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "global-uploader"
    }
  }, [_c('uploader', {
    ref: "uploader",
    staticClass: "uploader-app",
    attrs: {
      "options": _vm.options,
      "autoStart": false
    },
    on: {
      "file-success": _vm.onFileSuccess,
      "file-progress": _vm.onFileProgress,
      "file-error": _vm.onFileError,
      "files-added": _vm.onFilesAdded
    }
  }, [_c('uploader-unsupport'), _vm._v(" "), _c('uploader-btn', {
    ref: "uploadBtn1",
    attrs: {
      "id": "global-uploader-btn1",
      "attrs": _vm.attrs
    }
  }, [_vm._v("选择文件")]), _vm._v(" "), _c('uploader-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.panelShow),
      expression: "panelShow"
    }],
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return _c('div', {
          staticClass: "file-panel",
          class: {
            'collapse': _vm.collapse
          }
        }, [_c('div', {
          staticClass: "file-title"
        }, [_c('h3', {
          staticClass: "h3_title"
        }, [_vm._v("文件列表")]), _vm._v(" "), _c('div', {
          staticClass: "operate"
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "title": _vm.collapse ? '展开' : '折叠'
          },
          on: {
            "click": _vm.fileListShow
          }
        }, [_c('i', {
          staticClass: "iconfont",
          class: _vm.collapse ? 'icon-full-screen' : 'icon-zuixiaohua1'
        })]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "title": "关闭"
          },
          on: {
            "click": _vm.close
          }
        }, [_c('i', {
          staticClass: "iconfont icon-close"
        })])], 1)]), _vm._v(" "), _c('ul', {
          staticClass: "file-list"
        }, [_vm._l((props.fileList), function(file) {
          return _c('li', {
            key: file.id
          }, [_c('uploader-file', {
            ref: "files",
            refInFor: true,
            class: 'file_' + file.id,
            attrs: {
              "file": file,
              "list": true
            }
          })], 1)
        }), _vm._v(" "), (!props.fileList.length) ? _c('div', {
          staticClass: "no-file"
        }, [_c('i', {
          staticClass: "iconfont icon-empty-file"
        }), _vm._v(" 暂无待上传文件")]) : _vm._e()], 2)])
      }
    }])
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-260f1968"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Upload/globalUploader.vue
// module id = 1183
// module chunks = 1